export default function TokushohoContent() {
  const items = [
    { label: 'サイト運営者', value: 'ChromeChame' },
    { label: '連絡先', value: 'お問い合わせフォームから' },
    { label: 'お申し込み方法', value: '各、販売者サイトに準ずる' },
    { label: '商品引き渡し方法', value: '各、販売者サイトに準ずる' },
    { label: '商品引き渡し時期', value: '各、販売者サイトに準ずる' },
    { label: 'お支払い方法', value: '各、販売者サイトに準ずる' },
    { label: '返品・不良品について', value: '各、販売者サイトに準ずる' },
    {
      label: '責任の有無',
      value:
        '当サイトは、アフィリエイトプログラムにより商品をご紹介致しております。\n\nアフィリエイトプログラムとは、商品及びサービスの提供元と業務提携を結び、商品やサービスを紹介するインターネット上のシステムです。\n\n従いまして、当サイトの商品は当サイトが販売している訳ではありません。\n\nお客様ご要望の商品、お支払い等はリンク先の販売店と直接のお取引となりますので、特商法に基づく表記につきましてはリンク先をご確認頂けます様お願い致します。\n\n商品の価格、商品の詳細、消費税、送料、在庫数等の詳細は時として変わる場合も御座います。\n\n当サイトだけではなくリンク先のサイトもよくご確認頂けます様お願い致します。\n\nまた、当サイトの掲載情報をご利用頂く場合には、お客様のご判断と責任におきましてご利用頂けます様お願い致します。\n\n当サイトでは、一切の責任を負いかねます事ご了承願います。\n\n尚、掲載商品に関するお問合せはリンク先に御座います企業宛までお願い致します。\n\n当サイト管理者側ではお答え致しかねます事、ご了承ください。',
    },
  ];

  return (
    <main className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-amber-50 via-white to-amber-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <div className="inline-block px-4 py-2 bg-amber-600 text-white text-sm font-medium rounded-full mb-6">
            Legal
          </div>
          <h1 className="text-4xl md:text-5xl font-light text-gray-900 mb-4 tracking-wide">
            特定商取引法に基づく表記
          </h1>
          <p className="text-base text-gray-500">
            特定商取引に関する法律（特商法）第11条に基づき、以下の事項を表示いたします。
          </p>
        </div>
      </section>

      {/* Table Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="rounded-xl overflow-hidden border border-gray-100">
            <table className="w-full text-sm">
              <tbody>
                {items.map((item, index) => (
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? 'bg-white' : 'bg-amber-50/40'} border-b border-gray-100 last:border-b-0`}
                  >
                    <th className="w-40 md:w-56 py-5 px-6 text-left font-medium text-gray-700 align-top whitespace-nowrap">
                      {item.label}
                    </th>
                    <td className="py-5 px-6 text-gray-600 leading-relaxed">
                      <span style={{ whiteSpace: 'pre-line' }}>{item.value}</span>
                      {item.note && (
                        <p className="mt-2 text-xs text-gray-400">{item.note}</p>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Note */}
          <div className="mt-10 p-6 bg-amber-50/60 rounded-xl border border-amber-100">
            <p className="text-sm text-gray-600 leading-relaxed">
              ※ 本ページに記載の情報は予告なく変更される場合があります。最新情報は当ページをご確認ください。<br />
              ※ ご不明な点はお問い合わせフォームまたはメールにてお気軽にご連絡ください。
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
